import React from 'react';

import type { ChecklistReportImage } from '../../types/checklistImages';

import styled from 'styled-components';

interface ChecklistReportImagesProps {
  images?: ChecklistReportImage[];
  imagesPerRow?: 1 | 2 | 3;
  displayCaptions?: boolean;
  startOnNewPage?: boolean;
}

export function ChecklistReportImages({
  images = [],
  imagesPerRow = 2,
  displayCaptions = true,
  startOnNewPage = true,
}: ChecklistReportImagesProps) {
  if (images.length === 0) {
    return null;
  }

  return (
    <ReportImages
      className={`checklist-report-images ${
        startOnNewPage ? 'checklist-report-images--new-page' : ''
      }`}
    >
      <ReportImagesGrid
        className="checklist-report-images__grid"
        style={{
          gridTemplateColumns: `repeat(${imagesPerRow}, minmax(0, 1fr))`,
        }}
      >
        {images.map((image, index) => (
          <ReportImageFigure
            key={image.id}
            className="checklist-report-images__item"
          >
            <ReportImage
              src={image.url}
              alt={image.name || `Imagem do checklist ${index + 1}`}
            />

            {displayCaptions && (
              <FigCaption>{image.name || `Imagem ${index + 1}`}</FigCaption>
            )}
          </ReportImageFigure>
        ))}
      </ReportImagesGrid>
    </ReportImages>
  );
}

const ReportImages = styled.section`
  margin-top: 24px;
  /* break-before: page; */

  @media print {
    .report-images {
      display: block;
    }

    .report-image img {
      max-height: 300px;
    }
  }
`;

const ReportImagesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
`;

const ReportImageFigure = styled.figure`
  margin: 0;
  break-inside: avoid;
`;

const ReportImage = styled.img`
  display: block;
  width: 100%;
  height: 300px;
  object-fit: contain;
  border: 1px solid #ccc;
`;

const FigCaption = styled.figcaption`
  margin-top: 4px;
  font-size: 11px;
  text-align: center;
`;
